<div class="wrapper wrapper-dark">
  <div class="title-section mb-5">{{"I Clienti"|translate}}</div>

  <div class="flex-center">
    <span *ngFor="let c of getCustomerImportant()">
      <customer-box [customer]="c"></customer-box>
    </span>
  </div>


  <div class="customer-minor">
    <span class="white font-14 text-uppercase item-bord" *ngFor="let item of getCustomerMinor()">
      {{item.description}}<br>
    </span>
  </div>
</div>